import { useEffect, useState } from 'react';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectOverviewDto } from '../../../commonTypes/acs';
import { DateTime } from 'luxon';

const useHttpGetProjectOverviewOnMount = (projectId: string, fromDate?: string, toDate?: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isProjectOverviewReady, setProjectOverviewReady] = useState(false);
    const [data, setData] = useState<ProjectOverviewDto[]>([]);

    useEffect(() => {
        if (fromDate === undefined && toDate === undefined) {
            setProjectOverviewReady(true);
            setData([]);
            return;
        }

        setProjectOverviewReady(false);

        const from = fromDate ? encodeURIComponent(fromDate) : encodeURIComponent(DateTime.now().startOf('month').toISO());
        const to = toDate ? encodeURIComponent(toDate) : encodeURIComponent(DateTime.now().endOf('month').toISO());
        const { exec, abort } = acsApi.getProjectOverview({
            params: { projectId },
            query: { from, to, page: 0, size: 4 },
            onSuccess: res => setData(res.body),
            onError: error => console.log(error),
            onFinally: () => setProjectOverviewReady(true),
        });
        exec();
        return abort;
    }, [projectId, fromDate, toDate]);
    return { isProjectOverviewReady, data };
};

export default useHttpGetProjectOverviewOnMount;
